import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const usePanelStyles = makeStyles({
  root: {
    maxWidth: '85%',
    maxHeight: '79%',
    ...shorthands.padding(tokens.spacingVerticalXXL, tokens.spacingHorizontalXXL),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerText: {
    alignItems: 'center',
  },
});
